import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=e6a98d50"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"
import style0 from "./widget.vue?vue&type=style&index=0&id=e6a98d50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports